import { ISociometryCondition } from "shared/types/condition";
import { morenoTest } from "./sociometry";

export const conditions: ISociometryCondition[] = [morenoTest];
